<template>
    <div class="container-fluid">
        <section id="wrapper" class="error-page">
            <div class="error-box">
                <div class="error-body text-center">
                    <h1>403</h1>
                    <h3 class="text-uppercase">Forbidden Error!</h3>
                    <p class="text-muted m-t-30 m-b-30">YOU DON'T HAVE PERMISSION TO ACCESS ON THIS SERVER.</p>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: '403'
    }
</script>